/**
 * AWAC session-scoped UI state.
 *
 * Small sessionStorage-backed store for UI state that should survive a page
 * reload within the same tab — independent from the Messaging JWT storage.
 *
 * Currently persisted keys:
 *   booking   – { date, time, projectName, meetingType } once a booking is confirmed
 *   pendingMessage – a message queued from the landing page before the
 *                    conversation reached OPENED status
 *   proactiveDismissed – '1' once the proactive nudge was dismissed/engaged
 */

const STATE_KEY = 'AWAC_UI_STATE';

function readState() {
    try {
        const raw = sessionStorage.getItem(STATE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
        return {};
    }
}

function writeState(state) {
    try {
        sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
    } catch (e) {
        // Storage unavailable — degrade silently.
    }
}

export function getAwacState(key) {
    const state = readState();
    return key in state ? state[key] : undefined;
}

export function setAwacState(key, value) {
    const state = readState();
    state[key] = value;
    writeState(state);
}

export function clearAwacState(key) {
    const state = readState();
    delete state[key];
    writeState(state);
}

export function clearAllAwacState() {
    try {
        sessionStorage.removeItem(STATE_KEY);
    } catch (e) {
        // no-op
    }
}
